export default {
    websiteApi: {
        //网站
      website: {
            getList: 'api/screen/website/websiteList',
            saveWebsite: 'api/screen/website/saveWebsite',
            updateWebsite: 'api/screen/website/updateWebsite',
            delWebsite: 'api/screen/website/delWebsite',
        }

    }
}
